import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

import { petrol } from '../../../styles/mui/colors';

// Wohnmobil ab 7.5m

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.ReactNode}
 */
const IconVehiclesMotorHomeComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest} fontSize="large" viewBox="0 0 512 512">
      <svg
        height="512"
        id="Icons"
        strokeWidth={1.5}
        viewBox="0 0 60 60"
        width="512"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M59,37.278V34a4,4,0,0,0-4-4H53.589L49.7,23H50a5.006,5.006,0,0,0,5-5V16a7.009,7.009,0,0,0-7-7H35.108a5,5,0,0,0-2.573.713l-3.1,1.859A3,3,0,0,1,27.892,12H5a4,4,0,0,0-4,4V37.278A1.993,1.993,0,0,0,0,39v6a2,2,0,0,0,2,2h9.1a5,5,0,0,0,9.8,0H46.1a5,5,0,0,0,9.8,0H58a2,2,0,0,0,2-2V39A1.993,1.993,0,0,0,59,37.278ZM51.3,30H46a2,2,0,0,1-2-2V24a1,1,0,0,1,1-1h2.412ZM5,14H27.892a5,5,0,0,0,2.573-.713l3.1-1.859A3,3,0,0,1,35.108,11H48a5.006,5.006,0,0,1,5,5v2a3,3,0,0,1-3,3H45a3,3,0,0,0-3,3v4a4,4,0,0,0,4,4h9a2,2,0,0,1,2,2v3H38V20a2.966,2.966,0,0,0-.184-1H47a3,3,0,0,0,0-6H41a3,3,0,0,0-3,3v1H3V16A2,2,0,0,1,5,14Zm23,6V37H3V19H28.184A2.966,2.966,0,0,0,28,20Zm8,0v7H30V20a1,1,0,0,1,1-1h4A1,1,0,0,1,36,20Zm-6,9h6V39a1,1,0,0,1-1,1H31a1,1,0,0,1-1-1ZM40,17V16a1,1,0,0,1,1-1h6a1,1,0,0,1,0,2ZM16,49a3,3,0,1,1,3-3A3,3,0,0,1,16,49Zm35,0a3,3,0,1,1,3-3A3,3,0,0,1,51,49Zm7-4H55.9a5,5,0,0,0-9.8,0H20.9a5,5,0,0,0-9.8,0H2V39H28a3,3,0,0,0,3,3h4a3,3,0,0,0,3-3H58Z"
          strokeWidth={1.5}
        />
        <path
          d="M16,31h6a3,3,0,0,0,3-3V24a3,3,0,0,0-3-3H16a3,3,0,0,0-3,3v4A3,3,0,0,0,16,31Zm-1-7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4a1,1,0,0,1-1,1H16a1,1,0,0,1-1-1Z"
          strokeWidth={1.5}
        />
      </svg>
    </SvgIcon>
  );
};

IconVehiclesMotorHomeComponent.displayName = 'IconVehiclesMotorHome';
const IconVehiclesMotorHome = memo(IconVehiclesMotorHomeComponent);

export default IconVehiclesMotorHome;
